import classNames from "classnames";
import React from "react";


interface StickyElementProps{
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
    children: React.ReactNode;
}

const StickyElement = ({ right=0, left=0, bottom=0, top=0, children} : any) => {
    return (
        <div className={classNames(
            `sticky z-[90]`,
            `w-fit`,
            `max-w-fit`,
            `h-fit`,
            {
                [`top-${top}`]: top,
                [`right-${right}`]: right,
                [`bottom-${bottom}`]: bottom,
                [`left-${left}`]: left,
            }
            )}
        >
            {children}
        </div>
    )
}


export default StickyElement;